module.exports = __webpack_public_path__ + "img/3x.c64e265.jpg";